import { i18n } from 'reactifi/dist/es/i18n';
export default i18n;
